import { SharedModule } from '../../../shared/shared.module';
import { CategoryAssociationDetailsComponent } from './category-association-details.component';
import { CategoryAssociationDetailsResolver } from './category-association-details.resolver';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  imports: [
    NgbModule,
    SharedModule
  ],
  declarations: [CategoryAssociationDetailsComponent],
  exports: [CategoryAssociationDetailsComponent],
  providers: [CategoryAssociationDetailsResolver]
})
export class CategoryAssociationDetailsModule {}
